import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSessionContext } from '../../../contexts/SessionContext';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';


export default function NavButSessionCustomer( props ){
    //console.debug("RTS Break NavButSessionCustomer");

    const {setSessionCustomer} = useSessionContext();

    const handleClick = (e) => {
        setSessionCustomer(null);
    }
    
    return(
            <Tooltip title="Open Customer Selector">
                <IconButton
                id="sessionCustomerButton"
                onClick={handleClick} 
                color="inherit"
                sx={{ p: 0, mt:-1, mb:-1, fontSize:'3em', verticalAlign:'center' }}  
                >
                    <ArrowDropDownIcon fontSize='6em' sx={{p:0, m:0}} />
                </IconButton>
            </Tooltip>
    );
}



